var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.onTabClick },
          model: {
            value: _vm.auditType,
            callback: function($$v) {
              _vm.auditType = $$v
            },
            expression: "auditType"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "待审批", name: "1" } },
            [
              _c(
                "div",
                { staticClass: "search-term" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.auditingTable }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主订单号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "搜索条件", clearable: "" },
                            model: {
                              value: _vm.auditingTable.searchInfo.mainOrderNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.auditingTable.searchInfo,
                                  "mainOrderNo",
                                  $$v
                                )
                              },
                              expression: "auditingTable.searchInfo.mainOrderNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择油站" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditingTable.searchInfo.stationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditingTable.searchInfo,
                                    "stationId",
                                    $$v
                                  )
                                },
                                expression: "auditingTable.searchInfo.stationId"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAuditingSubmit }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onAuditingReset } },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.auditingTable.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "主订单号", prop: "mainOrderNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "子订单号", prop: "orderNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "油站名称", prop: "stationId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getStationName")(scope.row.stationId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "班次名称", prop: "shiftName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号", prop: "mobile" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单金额", prop: "totalSaleAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单应付", prop: "totalPay" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单实付", prop: "tradePay" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "支付方式", prop: "payChannel" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayChannelName")(
                                  scope.row.payChannel
                                )
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "退款方式", prop: "refundPayChannelName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "退款金额", prop: "refundAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "申请时间", prop: "CreatedAt" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.CreatedAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", prop: "remark" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticClass: "table-button",
                                attrs: { size: "small", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onAudit(scope.row)
                                  }
                                }
                              },
                              [_vm._v("审批")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.auditingTable.searchInfo.page,
                  "page-size": _vm.auditingTable.searchInfo.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.auditingTable.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleAuditingCurrentChange,
                  "size-change": _vm.handleAuditingSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "已审批", name: "2" } },
            [
              _c(
                "div",
                { staticClass: "search-term" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.auditedTable }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主订单号" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "搜索条件", clearable: "" },
                            model: {
                              value: _vm.auditedTable.searchInfo.mainOrderNo,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.auditedTable.searchInfo,
                                  "mainOrderNo",
                                  $$v
                                )
                              },
                              expression: "auditedTable.searchInfo.mainOrderNo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "选择油站" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditedTable.searchInfo.stationId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedTable.searchInfo,
                                    "stationId",
                                    $$v
                                  )
                                },
                                expression: "auditedTable.searchInfo.stationId"
                              }
                            },
                            _vm._l(_vm.stationOptions, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "提审日期" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "daterange",
                              "range-separator": "至",
                              "start-placeholder": "开始(含当天)",
                              "end-placeholder": "结束(含当天)",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.dateRangeValueArr,
                              callback: function($$v) {
                                _vm.dateRangeValueArr = $$v
                              },
                              expression: "dateRangeValueArr"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "审批结果" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "搜索条件"
                              },
                              model: {
                                value: _vm.auditedTable.searchInfo.refundStatus,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.auditedTable.searchInfo,
                                    "refundStatus",
                                    $$v
                                  )
                                },
                                expression:
                                  "auditedTable.searchInfo.refundStatus"
                              }
                            },
                            [
                              _c("el-option", {
                                key: 2,
                                attrs: { label: "审核通过", value: 2 }
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: { label: "审核不通过", value: 3 }
                              }),
                              _c("el-option", {
                                key: 4,
                                attrs: { label: "退款中", value: 4 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onAuditedSubmit }
                            },
                            [_vm._v("查询")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onAuditedReset } },
                            [_vm._v("重置")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.auditedTable.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "主订单号", prop: "mainOrderNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "子订单号", prop: "orderNo" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "油站名称", prop: "stationId" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getStationName")(scope.row.stationId)
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "班次名称", prop: "shiftName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号", prop: "mobile" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单总金额", prop: "totalSaleAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单总实收", prop: "totalPay" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "支付方式", prop: "payChannel" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("getPayChannelName")(
                                  scope.row.payChannel
                                )
                              )
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "退款方式", prop: "refundPayChannelName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "退款金额", prop: "refundAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "申请时间",
                      prop: "CreatedAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.CreatedAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", prop: "remark" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审批人", prop: "auditUserName" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "审批时间",
                      prop: "auditAt",
                      width: "160px"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.auditAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审批意见", prop: "auditRemark" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "审批结果", prop: "refundStatus" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.refundStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", effect: "plain" }
                                  },
                                  [_vm._v("审核通过")]
                                )
                              : _vm._e(),
                            scope.row.refundStatus == 3
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "warning", effect: "plain" }
                                  },
                                  [_vm._v("审核不通过")]
                                )
                              : _vm._e(),
                            scope.row.refundStatus == 4
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "info", effect: "plain" } },
                                  [_vm._v("退款中")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.auditedTable.searchInfo.page,
                  "page-size": _vm.auditedTable.searchInfo.pageSize,
                  "page-sizes": [10, 30, 50, 100],
                  total: _vm.auditedTable.total,
                  layout: "total, sizes, prev, pager, next, jumper"
                },
                on: {
                  "current-change": _vm.handleAuditedCurrentChange,
                  "size-change": _vm.handleAuditedSizeChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.closeDialog,
            visible: _vm.auditDialogVisible,
            title: "审批操作"
          },
          on: {
            "update:visible": function($event) {
              _vm.auditDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "right"
              }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "审批意见:", prop: "auditRemark" } },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              clearable: "",
                              placeholder: "请输入"
                            },
                            model: {
                              value: _vm.formData.auditRemark,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "auditRemark", $$v)
                              },
                              expression: "formData.auditRemark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "审批结果:", prop: "refundStatus" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { clearable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.formData.refundStatus,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "refundStatus", $$v)
                                },
                                expression: "formData.refundStatus"
                              }
                            },
                            [
                              _c("el-option", {
                                key: 2,
                                attrs: { label: "通过", value: 2 }
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: { label: "不通过", value: 3 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterDialog } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }